import type { TasksPeriod } from '../types';

// Период из календаря — в значение поля Date формы фильтров: пустой период
// снимает фильтр, как «Сброс», а даты, введённые с клавиатуры в обратном
// порядке, меняются местами.
export const normalizeTasksPeriod = (
  period: TasksPeriod | null
): TasksPeriod | undefined => {
  const [start, end] = period ?? [null, null];

  if (!start && !end) return undefined;

  if (start && end && start.isAfter(end, 'day')) return [end, start];

  return [start, end];
};
